import Index from 'views/system/Dashboard/Index';
import { WhatsappMessages } from 'views/system/Whatsapp/WhatsappMessages';
import Users from 'views/system/User/Users';
import User from 'views/system/User/User';
import Profile from 'views/system/Profile/Profile';
import Login from 'views/system/Login/Login';
import { ClientList } from 'views/system/Client/clients';
import { RouteList } from 'views/system/Route/route';
import { ProductList } from 'views/system/Product/product';
import { FormRoute } from 'views/system/Route/form-route';
import { FormClient } from 'views/system/Client/form-client';
import { FormProduct } from 'views/system/Product/form-product';
import { SaleScreen } from 'views/system/Sale/sale';
import { CityList } from 'views/system/City/city';
import { FormCity } from 'views/system/City/city-form';
import { ClientSaleForm } from 'views/system/Sale/client-sale-form';
import { ClientPreSaleForm } from 'views/system/Sale/client-pre-sale-form';
import { SaleSuccessScreen } from 'views/system/SaleSuccess/sales';
import { SaleSuccessScreenForm } from 'views/system/SaleSuccess/form-sale';
import { SyncList } from 'views/system/Syncs/syncs';
import { ReportList } from 'views/system/Report/report';
import { ReportPaymentList } from 'views/system/Report/report-payment';

const screenSystem = [
  {
    path: '/index',
    name: 'Dashboard',
    icon: 'ni ni-tv-2 text-primary',
    component: Index,
    layout: '/admin',
  },
  {
    path: '/user-profile',
    name: 'Perfil de Usuário',
    icon: 'ni ni-single-02 text-yellow',
    component: Profile,
    layout: '/admin',
  },
  {
    path: '/user',
    name: 'Usuários',
    icon: 'ni ni-single-02 text-yellow',
    component: Users,
    layout: '/admin',
  },
  {
    path: '/user/:id',
    name: 'Usuário',
    icon: 'ni ni-single-02 text-yellow',
    component: User,
    layout: '/admin',
  },
  {
    path: '/user/new',
    name: 'Novo Usuário',
    icon: 'ni ni-single-02 text-yellow',
    component: User,
    layout: '/admin',
  },
  {
    path: '/login',
    name: 'Login',
    icon: 'ni ni-key-25 text-info',
    component: Login,
    layout: '/auth',
  },
  {
    name: 'Cadastros',
    icon: 'ni ni-collection text-primary',
  },
  {
    name: 'Clientes',
    icon: 'ni ni-circle-08 text-info',
    component: ClientList,
    path: '/client',
    layout: '/admin',
  },
  {
    path: '/client/:id',
    name: 'Cliente',
    icon: 'ni ni-circle-08 text-yellow',
    component: FormClient,
    layout: '/admin',
  },
  {
    path: '/client/new',
    name: 'Novo Cliente',
    icon: 'ni ni-circle-08 text-yellow',
    component: FormClient,
    layout: '/admin',
  },
  {
    name: 'Produtos',
    icon: 'ni ni-box-2 text-success',
    component: ProductList,
    path: '/product',
    layout: '/admin',
  },
  {
    name: 'Produto',
    icon: 'ni ni-box-2 text-danger',
    component: FormProduct,
    path: '/product/:id',
    layout: '/admin',
  },
  {
    name: 'Novo Produto',
    icon: 'ni ni-box-2 text-danger',
    component: FormProduct,
    path: '/product/new',
    layout: '/admin',
  },
  {
    name: 'Rotas',
    icon: 'ni ni-delivery-fast text-danger',
    component: RouteList,
    path: '/route',
    layout: '/admin',
  },
  {
    path: '/route/:id',
    name: 'Rota',
    icon: 'ni ni-delivery-fast text-yellow',
    component: FormRoute,
    layout: '/admin',
  },
  {
    path: '/route/new',
    name: 'Nova Rota',
    icon: 'ni ni-delivery-fast text-yellow',
    component: FormRoute,
    layout: '/admin',
  },
  {
    path: '/sale',
    name: 'Vendas',
    icon: 'ni ni-cart text-danger',
    component: SaleScreen,
    layout: '/admin',
  },
  {
    path: '/sales',
    name: 'Pré-Vendas Realizadas',
    icon: 'ni ni-cart text-success',
    component: SaleSuccessScreen,
    layout: '/admin',
  },
  {
    path: '/sales/:id',
    name: 'Pré-Venda Realizada',
    icon: 'ni ni-cart text-success',
    component: SaleSuccessScreenForm,
    layout: '/admin',
  },
  {
    path: '/sale/pre-sale/new',
    name: 'Pré-venda',
    icon: 'ni ni-cart text-danger',
    component: ClientPreSaleForm,
    layout: '/admin',
  },
  {
    path: '/sale/execute-sale',
    name: 'Criar Venda',
    icon: 'ni ni-cart text-danger',
    component: ClientSaleForm,
    layout: '/admin',
  },
  {
    path: '/sale/execute-sale/:id',
    name: 'Criar Venda',
    icon: 'ni ni-cart text-danger',
    component: ClientSaleForm,
    layout: '/admin',
  },
  {
    path: '/sale/pre-sale/:id',
    name: 'Pré-venda',
    icon: 'ni ni-cart text-danger',
    component: ClientPreSaleForm,
    layout: '/admin',
  },
  {
    path: '/city',
    name: 'Cidades',
    icon: 'ni ni-map-big text-yellow',
    component: CityList,
    layout: '/admin',
  },
  {
    path: '/city/:id',
    name: 'Cidade',
    icon: 'ni ni-map-big text-primary',
    component: FormCity,
    layout: '/admin',
  },
  {
    path: '/city/new',
    name: 'Nova Cidade',
    icon: 'ni ni-map-big text-yellow',
    component: FormCity,
    layout: '/admin',
  },
  {
    path: '/resume-sync',
    name: 'Sincronizações Pendentes',
    icon: 'ni ni-map-big text-yellow',
    component: SyncList,
    layout: '/admin',
  },
  {
    path: '/report',
    name: 'Relatórios',
    icon: 'ni ni-map-big text-yellow',
    component: ReportList,
    layout: '/admin',
  },
  {
    path: '/report/payment',
    name: 'Relatórios de Pagamentos',
    icon: 'ni ni-map-big text-yellow',
    component: ReportPaymentList,
    layout: '/admin',
  },
  {
    path: '/whatsapp',
    name: 'WhatsApp',
    icon: 'ni ni-chat-round text-success',
    component: WhatsappMessages,
    layout: '/admin',
  },
];

export default screenSystem;
